import {
    Check,
    // BaseDatePicker,
    FormControll,
    FormControlPassword,
    PrimaryButton,
    // SelectControl,
} from '@/core/components'
// import { SelectCountry } from '@/core/widgets'
import { IRegisterForm } from '../../typing'
import moment from 'moment'
// import { genderOptions } from '@/modules/user/components/select-gender/gender.options'
import { TermsPolicy } from '@/core/widgets/term-policy'
import styles from './styles.module.css'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

interface IProps {
    values: IRegisterForm
    onChange: (key: keyof IRegisterForm, val: any) => void
    errors: Partial<IRegisterForm>
    submit: () => void
    disableEmail: boolean
}
export const RegisterForm = ({
    values,
    onChange,
    errors,
    submit,
    disableEmail,
}: IProps) => {
    const { t } = useTranslation()
    const [isCheck, setIsCheck] = useState(false)

    const handleCheck = (val: boolean) => {
        if (val) {
            onChange('birthday', moment(0).format())
        } else {
            onChange('birthday', null)
        }
        setIsCheck(val)
    }

    // const translateOptions = genderOptions.map((it, ind) => ({
    //     ...it,
    //     label: t(it.label),
    //     key: ind,
    // }))

    const starSymbol = '\u002A'

    // const disabledDate = (current: any) => {
    //     return current && moment().endOf('day') < current
    // }
    return (
        <form onSubmit={e => e.preventDefault()}>
            <div className={styles.form_container}>
                {/* <FormControll
                    onChangeVal={val => onChange('name', val)}
                    value={values.name}
                    label={`${t('fullname')} ${starSymbol}`}
                    error={errors.name}
                    autoComplete='name'
                    id='name'
                    name='name'
                    containerClassName='form_field_adaptive'
                /> */}
                <FormControll
                    disabled={disableEmail}
                    type='email'
                    onChangeVal={val => onChange('email', val)}
                    value={values.email}
                    label={`${t('email')} ${starSymbol}`}
                    error={errors.email}
                    autoComplete='email'
                    id='email'
                    name='email'
                    containerClassName='form_field_adaptive'
                />
                {/* <div style={{ width: '100%' }}>
                    <BaseDatePicker
                        error={errors.birthday}
                        value={values?.birthday}
                        status={errors.birthday ? 'error' : ''}
                        size='middle'
                        format={'DD/MM/YYYY'}
                        onChangeDate={val =>
                            onChange('birthday', val?.format('YYYY-MM-DD'))
                        }
                        disabledDate={disabledDate}
                        autoComplete='bday-day'
                        id='date'
                        name='date'
                    />
                </div> */}
                {/* <SelectControl
                    value={values.gender}
                    label={t('gender')}
                    items={translateOptions}
                    onChangeSelect={(val: any) =>
                        onChange('gender', val?.value)
                    }
                    id='gender'
                    dropdownClassName='gender_select'
                />
                <SelectCountry
                    onSelectCountry={val => {
                        onChange('location', val)
                    }}
                    label={t('countryResidence')}
                    id='countryResidence'
                    dropdownClassName='country_autocomplete'
                /> */}
                {/* <SelectCountry
                    onSelectCountry={val => {
                        onChange('nationality', val?.locationName)
                    }}
                    label={t('citizenship')}
                    id='citizenship'
                    dropdownClassName='country_autocomplete'
                /> */}
                <FormControlPassword
                    id='password'
                    value={values.password}
                    onChangeVal={val => onChange('password', val)}
                    label={`${t('password')} ${starSymbol}`}
                    error={errors.password}
                    containerClassName='form_field_adaptive'
                />

                <FormControlPassword
                    value={values.confirmPassword}
                    onChangeVal={val => onChange('confirmPassword', val)}
                    label={`${t('confirmPassword')} ${starSymbol}`}
                    error={errors.confirmPassword}
                    containerClassName='form_field_adaptive'
                />

                <div style={{ position: 'relative' }}>
                    <Check
                        styleLabel={{ color: '#5e626d', fontSize: 14 }}
                        label={t('areYou') + ' 18?'}
                        onChange={val => handleCheck(val.target.checked)}
                        checked={isCheck}
                    />
                    <>
                        {errors.birthday ? (
                            <p className={styles.error}>Field is required</p>
                        ) : null}
                    </>
                </div>
            </div>

            <TermsPolicy />

            <div className={styles.submit}>
                <PrimaryButton
                    label={`${t('signUp')}`}
                    withArrow={true}
                    onClick={submit}
                    style={{ width: '100%' }}
                />
            </div>
        </form>
    )
}
